export default [
  {
    path: "competitionRating",
    name: "competitionRating",
    component: (): Promise<any> => import(/* webpackChunkName: "webmaster:competitionRating" */ "@/views/Webmaster/CompetitionRating.vue")
  }
];
